<template>
  <div id="main-container" class="container--fluid px-0">
    <SubMenuHeader
      :title="placeName"
      :show-back-button="false"
      @onGoBack="goBack"
      @showVideo="$emit('showVideo')"
    />
    <div class="container mt-6">
      <div class="container--fluid">
        <div class="row">
          <div class="col ml-auto mr-auto text-center">
            <smtt-icon class="mt-10 mb-5" icon="check-circle" color="green" width="100"></smtt-icon>
          </div>
        </div>
        <div class="row">
          <div class="col mx-auto text-center">
            <div class="h3 mb-5">
              {{ this.$t('surveyFinished.title.label', { 'placeName': placeName }) }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col mx-auto text-center">
            <div class="h6 mb-5">
              <div v-if="nextRoomExists">
                {{ $t('surveyFinished.subTitle.nextRoom.label') }}
              </div>
              <div v-else>
                {{ $t('surveyFinished.subTitle.noNextRoom') }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="nextRoomExists" class="row mb-5">
          <div class="col mx-auto text-center">
            <app-button layout="label" full-width size="lg" @click="goToNextRoom">
              {{ $t('surveyFinished.button.goToNextRoom') }}
            </app-button>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col mx-auto text-center">
            <app-button full-width size="lg" layout="label" btn-type="outline" @click="goToRoomList">
              {{ $t('surveyFinished.button.goToRoomList') }}
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenuHeader from '../SubMenuHeader';
import AppButton from '@/components/AppButton';

export default {
  'name': 'SurveyFinishedSuccessfully',
  'props': {
    'roomId': 0,
    'roomAssignmentId': 0,
    'assignmentId': 0
  },
  'components': { SubMenuHeader, AppButton },
  data() {
    return {
      'placeName': '',
      'nextRoomData': {
        'roomId': null,
        'assignmentId': null,
        'roomAssignmentId': null,
        'roomName': '',
      }
    }
  },
  computed: {
    nextRoomExists() {
      return (this.nextRoomData.roomId != null && this.nextRoomData.assignmentId != null && this.nextRoomData.roomAssignmentId != null)
    }
  },
  'methods': {
    'goBack': function () {
      this.$router.back()
    },
    goToNextRoom() {
      this.$router.replace({
        'name': 'SurveyQuestionsScreen',
        'params': {
          'roomId': this.nextRoomData.roomId,
          'assignmentId': this.nextRoomData.assignmentId,
          'hasPermission': !this.$route.params.hasPermission,
          'roomAssignmentId': this.nextRoomData.roomAssignmentId,
        }
      })
    },
    goToRoomList() {
      this.$router.back();
    }
  },
  created() {
    const places = JSON.parse(localStorage.getItem('places'))

    places.forEach((place) => {
      if (place.roomAssignmentId === this.roomAssignmentId) {
        this.placeName = place.name
      }
    })

    let pendingPlaces = null
    if(places.filter((place) => place.roomWorkflowPhaseName !== null).length > 0) {
      pendingPlaces = places.filter((place) => (place.roomWorkflowPhaseName === 'Pending') && place.roomAssignmentId !== this.roomAssignmentId)
    } else {
      pendingPlaces = places.filter((place) => (place.answerStatus !== 2 && place.surveyStatus !== 2) && place.roomAssignmentId !== this.roomAssignmentId)
    }

    if (pendingPlaces.length > 0) {
      let place = pendingPlaces[0]

      this.nextRoomData.roomName = place.name
      this.nextRoomData.roomId = place.roomId
      this.nextRoomData.assignmentId = place.assignmentId
      this.nextRoomData.roomAssignmentId = place.roomAssignmentId
    }
  }
}
</script>

<style scoped>

</style>
